<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-error-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalError"
    ></button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="modalError"
      tabindex="-1"
      aria-labelledby="modalErrorLabel"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-danger" v-html="message"></div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalError",
  props: {
    message: {
      type: String,
      default: "",
    },
  },
};
</script>